module.exports = __webpack_public_path__ + "fonts/4b33f3d.eot";